import moment from 'moment'
import { takeEvery, call, put, all, select } from 'redux-saga/effects'
import { buildGETUrl } from '../../utilities/buildGETUrl'
import {
    loading,
    loading_assoc,
    putPublicPlaylists,
    putAssocMobilePublicTracks,
    putAssocPublicTracks,
    LOAD_ASSOC_PUBLIC_TRACKS,
    setSelectSongsAll
} from '../../store/PublicPlaylists/actions'
import { showAlertError } from '../../store/Alert/actions'
import axios from 'axios'
import { CLEAR_VALUE, changeValue } from '../../store/Search/actions'
import { LOAD_ALL_PUBLIC_VIDEO, putAllPublicVideo, saveSortVideoParams, SORT_VIDEOS, toggleAllPublicVideos_loading } from '../../store/ContentVideolists/actions'
import { SORT_ALL_VIDEOS } from '../../store/ContentAllVideolists/actions'

export default function* () {
    yield takeEvery(LOAD_ALL_PUBLIC_VIDEO, worker)
    yield takeEvery(CLEAR_VALUE, worker)
    yield takeEvery(SORT_VIDEOS, worker)
}

const emptyMap = new Map();


function* worker({ payload }) {
    console.log({ payload });

    yield put(toggleAllPublicVideos_loading(true))
    try {
        let playlistIds = yield select(state => state.videolists_all.selected)
        playlistIds = playlistIds[0];
        if (payload?.current) {
            playlistIds = payload.current
        }


        const public_tracks = (payload?.name || payload?.search_params || !payload?.offset) ?
            emptyMap
            : yield select(state => state.videolists.allPublicVideos);

        console.log({public_tracks});
            

        let public_tracks_table = yield select(state => state.videolists.assocPublicTracksTable)
        const search_name = yield select(state => state.search.songs.value)

        let searchName;
        if (payload && 'name' in payload) {
            searchName = payload?.name
        } else {
            searchName = search_name || ''
        }




        if (payload?.sort_params) {
            public_tracks_table = payload.sort_params;
            yield put(saveSortVideoParams(payload.sort_params));
        }

        let search_params = {}

        if (!payload) {
            payload = {}
        }

        if (payload?.offset != 0) {
            payload.offset = public_tracks?.size || payload.offset || 0
        }


        let params = !!searchName.length ?
            {
                ...search_params,
                playlist_id: playlistIds,
                offset: payload.offset, query: searchName
            } : {
                ...search_params,
                playlist_id: playlistIds,
                offset: payload.offset || 0
            }

        if (public_tracks_table.sort_field) {
            params[`sort[${[public_tracks_table.sort_field]}]`] = public_tracks_table.sort_dir;
        }

        if (!payload.offset) {
            yield put(putAllPublicVideo(emptyMap))

        }

        const fetchedAssocPublicTracks = yield call(fetchAssocPublicTracks, { ...params })


        const assocPublicTracks = [];

        const apt = fetchedAssocPublicTracks.success

        console.log({apt});
        


        apt.forEach(track => {
            assocPublicTracks.push({
                ...track,
                filename: buildGETUrl("clip/play", { id: track.id })
            });
        });


        yield put(putAllPublicVideo([...public_tracks, ...assocPublicTracks]))

    }
    catch (e) {
        yield put(showAlertError({
            errors: [`Ошибка сети при ${LOAD_ASSOC_PUBLIC_TRACKS}.`, e],
            text: "Плейлисты не были загружены. Попробуйте перезагрузить страницу." + e
        }))
    }
    finally {
        yield put(toggleAllPublicVideos_loading(false))
    }
}

function fetchAssocPublicTracks(params) {

    return axios.get(`/videolist/tracks/search`, {
        params: {
            limit: 50,
            ...params
        }
    })
        .then(response => response.data)
}